<template>
  <div class="costContainer">
    <div class="headerCon">
      <div class="left"><van-icon name="arrow-left" @click="$router.replace('/insuranceHome');" /></div>
      <div class="headerTit">（统一）推送时间设置</div>
      <div class="right">
      </div>
    </div>
    <div class="costContent">
      <van-form ref="form">
        <van-cell-group>
          <van-field @click="showYear" readonly :rules="[{ required: true }]" v-model="year" label="推送年度"
            placeholder="请选择推送年度" input-align="right">
            <template #button>
              <!-- <img class="fieldImg" src="@/assets/insurance/date.png" alt="" /> -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="isShowYear" position="bottom">
            <van-datetime-picker v-model="yearDate" type="date" title="选择年月日" @confirm="comfirmYear"
              @cancel="isShowYear = false" :min-date="minDate" :max-date="maxDate"
              :columns-order="['month', 'year', 'day',]" :formatter="formatter" />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field @click="showStartDate" readonly :rules="[{ required: true }]" v-model="startDate" label="开始日期"
            placeholder="请选择开始日期" input-align="right">
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="isShowStartDate" position="bottom">
            <van-datetime-picker v-model="startDateDate" type="month-day" title="选择月日" @confirm="comfirmStartDate"
              @cancel="isShowStartDate = false" :min-date="minDate" />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field @click="showEndDate" readonly :rules="[{ required: true }, endTime()]" v-model="endDate"
            label="结束日期" placeholder="请选择结束日期" input-align="right">
            <template #button>
              <!-- <img class="fieldImg" src="@/assets/insurance/date.png" alt="" /> -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="isShowEndDate" position="bottom">
            <van-datetime-picker v-model="endDateDate" type="month-day" title="选择月日" @confirm="comfirmEndDate"
              @cancel="isShowEndDate = false" :min-date="minDate" :max-date="maxDate" />
          </van-popup>
        </van-cell-group>
        <!-- <van-cell-group>
          <van-field @click="showTime" readonly v-model="time" label="每日推送时间" placeholder="请选择每日推送时间"
            input-align="right">
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="isShowTime" position="bottom">
            <van-datetime-picker v-model="timeDate" type="time" title="选择时分" @confirm="comfirmTime"
              @cancel="isShowTime = false" :min-date="minDate" :max-date="maxDate" />
          </van-popup>
        </van-cell-group> -->
        <van-cell-group>
          <van-field v-model="empnames" @click="selsectPushScope" readonly rows="2" autosize label="推送范围"
            type="textarea" placeholder="请选择推送范围" input-align="right" />
        </van-cell-group>
      </van-form>
    </div>
    <div class="footerBtn">
      <div>
        <van-button type="default" size="small" style="width: 30%"
          @click="$router.replace('/insuranceHome');">取消</van-button>
        <van-button type="info" size="small" style="width: 70%; background-color: #4ea27c"
          @click="handleConfirm">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/insurance.js";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  name: "policy",
  data() {
    return {
      isShowYear: false,
      year: '',
      yearDate: '',
      minDate: new Date(),
      maxDate: new Date('2065'),
      startDate: '',
      isShowStartDate: false,
      startDateDate: '',
      endDate: '',
      isShowEndDate: false,
      endDateDate: '',
      time: '',
      isShowTime: false,
      timeDate: '',
      createDate: moment(new Date()).format('YYYY'),
      empnames: '中国雷士照明控股有限公司', //员工姓名
      empnos: '', //员工工号
      OAInfo: []
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("pushScope");
  },
  mounted() {
    this.queryPushSchedules();


  },
  methods: {
    // 递归获取部门下的员工
    filterDepartment(department) {
      let asyncRoutes = [];
      department.forEach(item => {
        if (item.child && item.child.length > 0) {
          asyncRoutes = asyncRoutes.concat(this.filterDepartment(item.child));
        } else {
          asyncRoutes.push(item);
        }
      });

      return asyncRoutes;
    },
    //获取推送信息
    queryPushSchedules() {
      const json = {
        page: 1,
        pageSize: 1000,
        year: Number(this.createDate)
      };
      apis.queryPushSchedule(json).then(res => {
        if (res.code == 200) {

          this.year = res.data.length > 0 && res.data[0].pushYear ? res.data[0].pushYear + '年' : this.year;
          this.yearDate = res.data.length > 0 && res.data[0].pushYear ? new Date(res.data[0].pushYear) :  this.yearDate;
          this.startDate = res.data.length > 0 && res.data[0].startDate ? moment(res.data[0].startDate).format('MM月DD日') : this.startDate;
          this.startDateDate = res.data.length > 0 && res.data[0].startDate ? new Date(res.data[0].startDate) : this.startDateDate;
          this.endDate = res.data.length > 0 && res.data[0].endDate ? moment(res.data[0].endDate).format('MM月DD日') : this.endDate;
          this.endDateDate = res.data.length > 0 && res.data[0].endDate ? new Date(res.data[0].endDate) : this.endDateDate;

          const pushInfo = JSON.parse(sessionStorage.getItem('pushInfo'));
          if (pushInfo) {
            this.year = pushInfo.pushYear;
            this.yearDate = new Date(pushInfo.pushYear);
            this.startDate = pushInfo.startDate;
            this.startDateDate = new Date(pushInfo.startDate);
            this.endDate = pushInfo.endDate;
            this.endDateDate = new Date(pushInfo.endDate);
          }
          sessionStorage.removeItem('pushInfo');
          const department = JSON.parse(sessionStorage.getItem('pushScope'));
          if (department) {
            this.OAInfo = department.filter(item => item.nickname == '全部OA');
            const departmentLists = department.filter(item => item.nickname != '全部OA');
            this.empnos = this.filterDepartment(departmentLists).map(item => item.username).join(',');
            console.log('this.empnos', this.empnos);
          } else {
            this.empnos = res.data.length > 0 ? res.data[0].pushObject : '';
            const OA = res.data.length > 0 && res.data[0].pushOa == 1 ? ',全部OA' : '';
            sessionStorage.setItem('empnos', JSON.stringify(this.empnos + OA));
          }
        }
      });
    },
    // 年份格式化
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
    },
    // 显示年
    showYear() {
      this.minDate = new Date();
      this.isShowYear = true;
    },
    //确认年
    comfirmYear(value) {
      this.year = moment(value).format('YYYY年');
      this.createDate = moment(value).format('YYYY');
      this.yearDate = new Date(value);
      this.isShowYear = false;
      this.startDate = '';
      this.startDateDate = '';
      this.endDate = '';
      this.endDateDate = '';
      this.time = '';
      this.minDate = new Date(value);
      this.queryPushSchedules();
    },
    // 显示开始月日
    showStartDate() {
      this.isShowStartDate = true;
    },
    //确认开始月日
    comfirmStartDate(value) {
      this.startDate = moment(value).format('MM月DD日');
      this.startDateDate = new Date(value);
      this.isShowStartDate = false;
    },
    // 显示结束月日
    showEndDate() {
      this.isShowEndDate = true;
    },
    //确认结束月日
    comfirmEndDate(value) {
      this.endDate = moment(value).format('MM月DD日');
      this.endDateDate = new Date(value);
      this.isShowEndDate = false;
    },
    // 显示时间
    showTime() {
      this.isShowTime = true;
    },
    //确认时间
    comfirmTime(value) {
      console.log('value222', value);
      this.time = value;
      this.isShowTime = false;
    },
    // startTime() {
    //   let saterTime = this.startDateDate;
    //   let endTime = this.endDateDate;
    //   return {
    //     validator: () => {
    //       return saterTime
    //         ? new Date(saterTime).getTime() < new Date(endTime).getTime()
    //         : true;
    //     },
    //     message: "结算时间不能小于开始时间",
    //     trigger: "onBlur"
    //   };
    // },
    // 结束时间
    endTime() {
      let saterTime = this.startDateDate;
      let endTime = this.endDateDate;
      return {
        validator: () => {
          return saterTime
            ? new Date(saterTime).getTime() < new Date(endTime).getTime()
            : true;
        },
        message: "结束时间不能小于等于开始时间",
        trigger: "onBlur"
      };
    },
    // 选择推送范围
    selsectPushScope() {
      this.$router.replace('/selectDepartment');
      const json = {
        pushYear: Number(moment(this.year, 'YYYY年').format('YYYY')),
        startDate: moment(this.year, 'YYYY年').format('YYYY') + '-' + moment(this.startDateDate).format('MM-DD'),
        endDate: moment(this.year, 'YYYY年').format('YYYY') + '-' + moment(this.endDateDate).format('MM-DD'),
      };
      sessionStorage.setItem('pushInfo', JSON.stringify(json));
    },
    // 确认推送范围
    handleConfirm() {
      this.$refs.form.validate().then(() => {
        const json = {
          pushYear: Number(moment(this.year, 'YYYY年').format('YYYY')),
          startDate: moment(this.year, 'YYYY年').format('YYYY') + '-' + moment(this.startDateDate).format('MM-DD'),
          endDate: moment(this.year, 'YYYY年').format('YYYY') + '-' + moment(this.endDateDate).format('MM-DD'),
          pushObject: this.empnos,
          pushOa: this.OAInfo.length > 0 ? 1 : ''
        };
        console.log('json', json, this.year);
        apis.pushScheduleAddOrUpdate(json).then(res => {
          if (res.code == "200") {
            if (res.code == 200) {
              this.$router.replace('/insuranceHome');
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

::v-deep {
  .van-field__error-message {
    text-align: right;
  }
}

.costContainer {
  padding-top: 20px;

  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .costContent {
    height: calc(100vh - 218px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }

  .footerBtn {
    // position: fixed;
    // bottom: 0;
    padding: 20px 0;
    background-color: #f7f9fa;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
